module.exports = __webpack_public_path__ + "static/media/refresh-icon.6964aaf5.svg";